module.exports = __webpack_public_path__ + "static/media/webd5.cbc6f741.jpg";